var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-title',{attrs:{"titleText":_vm.pageTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }